import styled from "styled-components";

export const Wrapper = styled.div`
  min-height: var(--app-height);
  display: grid;
  grid-template-columns: repeat(7, 1fr);

  div {
    padding: 10px;
    flex-direction: column;
    display: grid;
    place-items: center;
    grid-gap: 5px;
    cursor: pointer;
    span {
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;
